import { render, staticRenderFns } from "./setTableColumn.vue?vue&type=template&id=5d1a75f5&scoped=true&"
import script from "./setTableColumn.vue?vue&type=script&lang=js&"
export * from "./setTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./setTableColumn.vue?vue&type=style&index=0&id=5d1a75f5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a75f5",
  null
  
)

export default component.exports